import React, { useState, useEffect, useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { getEmployees } from '../../../services/employeeService';
import { parseTableParams } from '../../../utils/Utils';
import PersonCell from '../../../components/ui/PersonCell';
import DataTable from '../../../components/ui/DataTable';

const Container = styled.div``;

// Bir çalışanın departmanı Employee üzerinde DEĞİL, aktif pozisyonunda durur
// (Employee → User → UserPosition → Position.DepartmentId). Bu çözümlemenin tek
// sahibi backend'in `departmentId` süzgeci (EmployeeDataAccess) — sekme kendi
// köprüsünü kurmaz, o süzgeci çağırır. Bu yüzden sekme SALT-OKUNUR: buradan
// "çalışan ekle" demek pozisyon atama akışını baypas etmek olurdu.
export default function DepartmentEmployeesTab({ departmentId }) {
  const { t } = useTranslation();
  const history = useHistory();

  const [queryParams, setQueryParams] = useState({ pageSize: 10, pageNumber: 1 });
  const [filterList, setFilterList] = useState([]);
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({ totalRowCount: 0, pageIndex: 0, pageSize: 10 });
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    setFetching(true);
    // departmentId İSTEK ANINDA eklenir, queryParams state'inin İÇİNDE tutulmaz:
    // `handleDataStateChange` state'i parseTableParams çıktısıyla komple değiştiriyor,
    // yani state'te taşınsaydı ilk sayfa/filtre değişiminde sessizce düşer ve sekme
    // ŞİRKETİN TAMAMINI listelerdi.
    //
    // orderBy varsayılanı da burada: backend'in sıralama switch'i tanımadığı alanda
    // sessizce `CreateDate desc`'e düşüyor ("fullname" desteklenmiyor), o yüzden
    // kullanıcı bir kolona tıklamadığı sürece listeyi ada göre sıralı tutuyoruz.
    getEmployees({
      orderBy: 'firstName',
      orderDir: 'asc',
      ...queryParams,
      departmentId,
    })
      .then((res) => {
        const result = res.data?.data;
        const items = Array.isArray(result) ? result : (result?.data || []);
        setData(items);
        setPagination({
          totalRowCount: result?.totalRowCount || items.length,
          pageIndex: result?.pageIndex ? result.pageIndex - 1 : 0,
          pageSize: result?.pageSize || items.length || 10,
        });
      })
      .catch(() => {})
      .finally(() => setFetching(false));
  }, [departmentId, queryParams]);

  const columns = useMemo(() => [
    {
      name: 'fullName',
      label: t('employee.fullName'),
      options: {
        // sort: false — backend "fullname" alanını tanımıyor, sıralama isteği
        // sessizce CreateDate'e düşerdi. Filtre ise destekli (fullName[like]).
        filter: true, sort: false, filterType: 'textField', filterOptions: { defaultOp: 'like' },
        customBodyRender: (value, tableMeta) => {
          const row = data[tableMeta.rowIndex];
          const name = value || `${row?.firstName || ''} ${row?.lastName || ''}`.trim();
          return <PersonCell name={name} profilePicture={row?.profilePicture} />;
        },
      },
    },
    {
      name: 'registrationNumber',
      label: t('employee.registrationNumber'),
      options: {
        filter: true, sort: false, filterType: 'textField', filterOptions: { defaultOp: 'like' },
        customBodyRender: (v) => v || '-',
      },
    },
    {
      name: 'titleName',
      label: t('employee.titleName'),
      options: { filter: false, sort: false, customBodyRender: (v) => v || '-' },
    },
    {
      name: 'corporateEmail',
      label: t('employee.corporateEmail'),
      options: { filter: true, sort: true, filterType: 'textField', filterOptions: { defaultOp: 'like' } },
    },
    {
      name: 'locationName',
      label: t('employee.branch'),
      options: { filter: false, sort: false, customBodyRender: (v) => v || '-' },
    },
    {
      name: 'managerName',
      label: t('employee.manager'),
      options: { filter: false, sort: false, customBodyRender: (v) => v || '-' },
    },
  ], [t, data]);

  const handleDataStateChange = useCallback((action, tableState) => {
    setFilterList(tableState.filterList);
    setQueryParams(parseTableParams(tableState, columns));
  }, [columns]);

  const handleFilterConfirm = useCallback((newFilterList) => {
    setFilterList(newFilterList);
  }, []);

  const handleRowClick = useCallback((row) => {
    history.push(`/employees/${row.id}`);
  }, [history]);

  return (
    <Container>
      <DataTable
        title={t('department.employees')}
        fetching={fetching}
        columns={columns}
        data={data}
        totalRowCount={pagination.totalRowCount}
        pageIndex={pagination.pageIndex}
        pageSize={pagination.pageSize}
        filterList={filterList}
        onFilterConfirm={handleFilterConfirm}
        onTableChanged={handleDataStateChange}
        onRowClick={handleRowClick}
      />
    </Container>
  );
}
